<nx-pageTitle-box class="mb-3" [label]="'Geräte'" [icon]="'icon-mobile-device'" [iconToolTip]="'Gräte'"
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'settings'">
</nx-pageTitle-box>

<nx-table-header
  label="Geräteliste">
  <ng-template nxTemplate="end">
    <input
      pInputText
      type="text"
      (input)="mobileDeviceTable.filterGlobal($event.target?.['value'], 'contains')"
      class="p-inputtext p-component p-element mr-3"
    placeholder="Gerät suchen" />
  </ng-template>
</nx-table-header>

<p-table
  #mobileDeviceTable
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [value]="dataSource?.data"
  [scrollable]="true"
  [paginator]="true"
  [rows]="15"
  [rowsPerPageOptions]="[15, 20, 50]"
  [totalRecords]="dataSource?.totalElements"
  [loading]="loading"
  [sortField]="sortProperty" 
  [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} von {totalRecords}"
  [resizableColumns]="true">
  <ng-template pTemplate="caption">
    <div class="flex flex-row">
      <div class="basis-2/3 flex flex-row gap-2">
        <!-- no filter -->
      </div>
      <div class="basis-1/3 flex flex-row justify-end">
        <p-dropdown
          placeholder="Sortierung"
          [styleClass]="'sort'"
          appendTo="body"
          [ngModel] = "sortModel"
          [options]="sortOptions"
          optionLabel="label"
          [showClear]="false"
          (onChange)="sort($event)">
        </p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th>Name</th>
      <th>Update-Status</th>
      <th>Offene Uploads</th>
      <th>Nutzer</th>
      <th>App-Version</th>
      <th>Platform</th>
      <th>Zuletzt gesehen</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-mobileDevice>
    <tr class="clickable">
      <td>
        <p-tag 
        [value]="updateLabel(mobileDevice?.updateState)"
        [severity]="calculateSeverity(mobileDevice?.updateState)">
      </p-tag>
      </td>
      <td>{{mobileDevice?.uploads?.length}}</td>
      <td>{{mobileDevice?.user?.firstName}} {{mobileDevice?.user?.lastName}}</td>
      <td>{{mobileDevice?.name}}</td>
      <td>{{mobileDevice?.appVersion}}</td>
      <td>{{mobileDevice?.platform}}</td>
      <td>{{mobileDevice?.lastSeenDateTime | date:'dd.MM.yy HH:mm'}}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="emptyMessage">Keine Geräte gefunden.</td>
    </tr>
  </ng-template>
</p-table>

